<template>
    <div>
        <form
            action=""
            v-if="task"
        >
            <div
                v-for="stageOption in stages"
                :key="`stage_${stageOption.stage}`"
                class="mb-2 border rounded-sm bg-white p-2"
            >
                <h5 class="font-weight-bolder mb-2">
                    Stage {{ stageOption.stage }}
                </h5>
                <div
                    v-for="(option, index) in stageOption.options"
                    :key="`stage_${stageOption.stage}_${index}`"
                >
                    <input
                        :id="`stage_${stageOption.stage}_${index}`"
                        type="checkbox"
                        :name="stageOption.stage"
                        @change="(event) => {stageOptionChanged(stageOption.stage, option, event.target.checked)}"
                        :checked="stageOption.option === option"
                        :value="option"
                        :disabled="isStageDisabled(stageOption.stage)"
                    >
                    <label :for="`stage_${stageOption.stage}_${index}`">{{ option }}</label>
                </div>
                <div>
                    <label class="label">Notes</label>
                    <textarea
                        rows="2"
                        class="form-control"
                        v-model="stageOption.notes"
                        placeholder="Notes..."
                        @change="(e) => notesChanged(stageOption.stage, e.target.value)"
                    />
                </div>
                <div v-if="stageOption.user">
                    <p class="stage-user">
                        {{ stageOption.user.name }} updated at {{ stageOption.updated_at | datetime }}
                    </p>
                </div>
            </div>
            <div>
                <button
                    type="button"
                    class="btn btn-danger"
                    @click="deleteClicked"
                >
                    Delete
                </button>
            </div>
        </form>
        <p v-if="task === null">
            Loading task, please wait...
        </p>
    </div>
</template>
<script>
import Service, { deleteTask } from "../../../services/TaskService";
import UsesErrors from "../../../mixins/UsesErrors";
export default {
    mixins: [UsesErrors],
    props: {
        taskId: {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        return {
            task: null,
            loading: false,
        };
    },
    computed: {
        stages() {
            return this.task.stage_options.map(stageOption => {
                const stage = this.getStage(stageOption.stage) || {};
                return {
                    ...stageOption,
                    ...stage,
                }
            });
        }
    },
    mounted() {
        this.loadTask();
    },
    methods: {
        loadTask() {
            this.loading = true;
            Service.get(this.taskId)
                .then(({ data }) => {
                    this.task = data;
                    this.loading = false;
                })
                .catch((err) => {
                    console.error(err);
                    this.showErrorMessage("Failed to load task");
                    this.$router.back();
                });
        },
        stageOptionChanged(stage, option, checked) {
            const taskStage = this.stages.find(s => s.stage === stage);
            Service.updateStage(this.task.id, stage, checked ? option : null, taskStage.notes).then(({data}) => {
                this.task = data;
                this.$emit('change');
            });
        },
        notesChanged(stage, value) {
            const taskStage = this.stages.find(s => s.stage === stage);
            Service.updateStage(this.task.id, stage, taskStage.option, value).then(({data}) => {
                this.task = data;
                this.$emit('change');
            });
        },
        getStage(stageNumber) {
            return this.task.stages.find(s => s.stage === stageNumber);
        },
        isStageDisabled(stageNumber) {
            if (stageNumber <= 1) {
                return false;
            }

            const prevStage = this.stages.find(s => s.stage === (stageNumber-1));

            return prevStage ? prevStage.option === undefined : false;
        },
        deleteClicked() {
            const confirm = window.confirm('Are you sure you want to delete this task?');
            if (!confirm) {
                return;
            }
            deleteTask(this.task.id).then(() => {
                this.$emit('change');
                this.$emit('close');
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.stage-user {
    font-size: .9em;
    color: #999;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/office/task-manager/EditTask.vue